import { render } from "./fldsRadarChart.vue?vue&type=template&id=75ae495a&scoped=true"
import script from "./fldsRadarChart.vue?vue&type=script&lang=js"
export * from "./fldsRadarChart.vue?vue&type=script&lang=js"

import "./fldsRadarChart.vue?vue&type=style&index=0&id=75ae495a&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ae495a"]])

export default __exports__